<nz-spin [nzSpinning]="loading">
  <div class="dialog-content custom-dialog-container">

    <div class="container">
      <div class="json-keys">
        <h2>{{'importacao.json.jsonTitle'|translateTA}}</h2>
        <div class="json-key" *ngFor="let key of jsonKeys">
          <div class="key-row" cdkDrag [cdkDragData]="key" (cdkDragEnded)="drop($event, key)">
            <span>{{key.name}}</span>
            <div class="dpara-column" cdkDropList [id]="'json-' + key.name" (cdkDropListDropped)="drop($event, key)">
              <input type="text" [(ngModel)]="key.mapping" readonly>
            </div>
          </div>
        </div>
      </div>
      <div class="table-cards">
        <button nz-button nzType="primary">{{'importacao.json.addTable'|translateTA}}</button>
        <nz-collapse>
          <nz-collapse-panel *ngFor="let table of tables" [nzHeader]="table.name">
            <div class="card-list" cdkDropList [cdkDropListData]="table.columns" [id]="'table-' + table.name" (cdkDropListDropped)="drop($event, table)">
              <div class="card" *ngFor="let column of table.columns" cdkDrag [cdkDragData]="column" (cdkDragEnded)="drop($event, column)">
                {{column}}
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>

  </div>

  <div class="dialog-actions">
    <button nz-button nzDanger (click)="dialogRef.close()">{{'importacao.btn.cancel'|translateTA}}</button>
    <button nz-button nzType="primary" (click)="dialogRef.close({
      columns: columns,
      hasHeader: hasHeader,
      hasUpdate: hasUpdate,
      headerLineNumber: headerLineNumber
    })" cdkFocusInitial>{{'importacao.btn.ok'|translateTA}}</button>
  </div>
</nz-spin>
